






import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ImageContainer from '@/components/ImageManager/ImageContainer.vue';
import { Action, Getter } from 'vuex-class';
import { Image, ImageMonth } from '@/types/image';
import EventBus from '@/plugins/EventBus';

@Component({ components: { ImageContainer } })
export default class ImageGalleryModal extends Vue {
  @Action('images/getImageMonths') getImageMonths!: Function;
  @Action('images/getPage') getPage!: Function;
  @Getter('images/images') images!: Image[];
  @Getter('images/imageMonths') imageMonths!: ImageMonth[];

  showModal: boolean = false;

  onImageSelected(image: Image) {
    EventBus.$emit('gallery:select', image.path);
    this.showModal = false;
  }

  mounted() {
    if (this.images.length < 1) {
      const page = 1;
      this.getPage({ page });
      this.getImageMonths();
    }
    EventBus.$on('gallery:show', () => (this.showModal = true));
  }
}
